<template>
  <div class="box">
    <h1 class="title">商户管理系统<span class="logout" @click="logout">退出</span></h1>
  </div>
</template>

<script>
import {AdminRequestUtil} from '../utils/AdminRequestUtil'

export default {
  name: 'NavHeaderComponent',
  methods: {
    logout () {
      let that = this
      AdminRequestUtil.logout({}, function (response) {
        if (response.result) {
          that.$message.success('操作成功')
          setTimeout(function () {
            window.location.reload()
          }, 2000)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.box{
  .title{
    font-size: 20px;
    margin: 0;
    padding: 0;
    color: #ddd;
  }
  padding:20px;
  border-bottom: solid 2px #ddd;
  box-shadow: #ddd 0 2px 0 0 ;
  background-image: linear-gradient(#687078, #545c64);

  .logout{
    float: right;
    &:hover{
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavHeaderComponent.vue